export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '热门排行', href: '#ranking' },
        { label: '深度爆料', href: '#cards' },
        { label: '焦点专题', href: '#carousel' },
        { label: '专题合集', href: '#index' },
        { label: '话题标签', href: '#topics' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问答', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: '联系我们', href: '#contact' },
        { label: 'App下载', href: '#app' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-foreground-900 text-background-100 pt-14 md:pt-20 pb-8">
      <div className="section-container">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-fill text-primary-400 text-xl"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">每日黑料</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              每日黑料大赛热门排行榜，汇集全网黑料评选与实时吃瓜PK热度数据。
              理性吃瓜，拒绝造谣——让每一次点击都值得。
            </p>
          </div>

          {/* Link columns */}
          {footerLinks.map((col, ci) => (
            <div key={ci}>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
                {col.title}
              </h4>
              {col.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {col.links.map((link, li) => (
                    <li key={li}>
                      <a
                        href={link.href}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <ul className="space-y-2.5">
                  {['合作媒体', '友情链接', '品牌合作'].map((p, pi) => (
                    <li key={pi}>
                      <span className="text-sm text-background-500">{p}</span>
                      <span className="text-xs text-background-600 ml-2">虚位以待</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 每日黑料. 理性吃瓜，拒绝造谣。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">社区公约</span>
          </div>
        </div>
      </div>
    </footer>
  );
}